var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.124 5.61157L26 3.7438L22.2562 0L20.3884 1.86777L13 9.2562L5.61157 1.87603L3.7438 0L0 3.7438L1.86777 5.61157L9.2562 13L1.87603 20.3884L0 22.2562L3.7438 26L5.61157 24.1322L13 16.7438L20.3884 24.1322L22.2562 26L26 22.2562L24.1322 20.3884L16.7438 13L24.1322 5.61157H24.124Z","fill":"white"}));
}

Close.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Close;

Close.default = Close;
